import { toast } from "react-hot-toast";
import ToastRoot from "./ToastRoot";
const createToast = (content, options) => {
  toast(content, options);
};
const createToastPromise = (content, messages, options) => toast.promise(content, messages, options);
export { ToastRoot, createToast, createToastPromise };